import { requestApi } from './Api';

export const fetchData = async (url, navigate, params) => requestApi({ url, params, navigate });
